"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    label: "Date of Transfer",
                    scope: "#/properties/dateOfTransfer",
                    options: {
                        disableFuture: true,
                    },
                },
                {
                    type: "Control",
                    label: "Hospital transferred to",
                    scope: "#/properties/hospitalTransferredTo",
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    label: "Reason for Transfer",
                    scope: "#/properties/reasonForTransfer",
                },
                {
                    type: "Control",
                    label: "Case Manager at Hospital",
                    scope: "#/properties/caseManagerAtHospital",
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "HorizontalLayout",
                    scope: "#/properties/phoneNumberWithCountryCode",
                    elements: [
                        {
                            type: "Control",
                            scope: "#/properties/phoneNumberWithCountryCode/properties/countryCode",
                            label: "Code",
                        },
                        {
                            type: "Control",
                            scope: "#/properties/phoneNumberWithCountryCode/properties/phoneNumber",
                            label: "Phone Number",
                        },
                    ],
                },
                {
                    type: "Control",
                    label: "Fax Number to Hospital",
                    scope: "#/properties/faxNumberToHospital",
                    options: {
                        countryCodePath: "phoneNumberWithCountryCode.countryCode",
                    },
                },
            ],
        },
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
        {
            type: "Control",
            label: "Physician Notified",
            scope: "#/properties/physicianNotified",
            options: {
                format: "radio",
            },
        },
    ],
};
